module.exports = __webpack_public_path__ + "files/a3c7588e63334087f253bc0089d9a8b4.png";